import {types} from './types';

const setGetListPaymentSystemAction = (payload) => {
    return {
        type: types.SET_LIST,
        payload,
      }
}

export {
  setGetListPaymentSystemAction,
}